import React from 'react';
import Isvg from 'react-inlinesvg';

import { bem } from 'helpers/class-name';

import { Card } from 'components/Card';
import Message from 'components/Message';

import { ICONS } from 'constants/icons';
import { intlMessage } from 'constants/propTypes';

import './MissingObjectsCard.scss';

const { block } = bem('missing-objects-card');

const MissingObjectsCard = ({ titleMessage, copyMessage }) => (
  <Card flush className={block()}>
    <Isvg src={ICONS.infoYellow} />
    <div className="ml-">
      <Message as="div" className="text--bold" message={titleMessage} />
      <Message message={copyMessage} />
    </div>
  </Card>
);

MissingObjectsCard.propTypes = {
  titleMessage: intlMessage,
  copyMessage: intlMessage,
};

export default MissingObjectsCard;
